import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ui/molecules/Modal';
import { InlineNotification } from '@ui/molecules/InlineNotification';
import { Button } from '@ui/atoms/Button';
import { Loader } from '@ui/atoms/Loader';
import { Text } from '@ui/atoms/Text';
import { translate } from '@utils/i18n';
import { NAMESPACE } from '../constants';
function KeepMoreCompleteModal({ isOpen, isSubmitting, isLoading, hasError, summary, onClose, onConfirm }) {
    var _a;
    const resolvable = (_a = summary === null || summary === void 0 ? void 0 : summary.groupsResolvableByCompleteness) !== null && _a !== void 0 ? _a : 0;
    const isReady = !isLoading && !hasError && summary !== null;
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose, ariaLabel: translate('keep_more_complete_modal_title', { namespace: NAMESPACE }) },
        React.createElement(ModalHeader, { title: translate('keep_more_complete_modal_title', { namespace: NAMESPACE }) }),
        React.createElement(ModalBody, null,
            isLoading && React.createElement(Loader, null),
            hasError && (React.createElement(InlineNotification, { variant: "error" }, translate('keep_more_complete_load_error', { namespace: NAMESPACE }))),
            isReady && resolvable === 0 && (React.createElement(Text, { variant: "body", as: "p" }, translate('keep_more_complete_none', { namespace: NAMESPACE }))),
            isReady && resolvable > 0 && (React.createElement(Text, { variant: "body", as: "p" }, translate('summary', { namespace: NAMESPACE, resolvable, total: summary.groupsTotal })))),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { variant: "secondary", type: "button", onClick: onClose, disabled: isSubmitting }, translate('cancel', { namespace: NAMESPACE })),
            React.createElement(Button, { variant: "primary", type: "button", disabled: !isReady || resolvable === 0 || isSubmitting, onClick: () => {
                    void onConfirm();
                } }, translate('confirm', { namespace: NAMESPACE })))));
}
export default KeepMoreCompleteModal;
